import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, DynamicFormDto, DynamicPayloadDto, MemberDto, MemberSearchDto, ResultListDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpMemberService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/member', authService);
	}
	public getForm(): Observable<DynamicFormDto> {
		return super.doGet(true, "/form");
	}
	public get(id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${id}`);
	}
	public getFull(id: number): Observable<MemberDto> {
		return super.doGet(true, `/${id}/full`);
	}
	public create(payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/`, payload);
	}
	public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public getAll(pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<MemberDto>> {
		return super.doGet(true, `/?pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}
	public findMembers(filters: MemberSearchDto, pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<MemberDto>> {
		return super.doPost(true, `/search?pageIndex=${pageIndex}&pageSize=${pageSize}`, filters);
	}
}
